import React from 'react'
import { Activity } from '@citruscamps/citrus-client'

interface IProps {
  activity: Activity
}

export const DefaultActivityText = ({ activity }: IProps): React.ReactElement => {
  const [item, action] = activity.type.split('.').map((i) => i.replace('_', ' '))
  return (
    <>
      {activity.user ? activity.user.first_name : 'Citrus'} {action.replace('_', ' ')}{' '}
      {item.replace('_', ' ') + (activity.type.includes('bulk_') ? 's' : '')}.
    </>
  )
}
